function Toast({ message, type = "success" }) {
  const colors = {
    success: {
      background: "#dcfce7",
      color: "#166534",
      border: "#bbf7d0",
    },
    error: {
      background: "#fee2e2",
      color: "#991b1b",
      border: "#fecaca",
    },
  };

  const current = colors[type] || colors.success;

  return (
    <div
      style={{
        position: "fixed",
        top: 90,
        right: 20,
        backgroundColor: current.background,
        color: current.color,
        border: `1px solid ${current.border}`,
        padding: "14px 18px",
        borderRadius: 12,
        fontWeight: 600,
        zIndex: 2000,
        boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
      }}
    >
      {message}
    </div>
  );
}

export default Toast;